import React, { useEffect, useState } from "react";
import { TypeAnimation } from "react-type-animation";
import { motion } from "framer-motion";

const AboutCardMatrix = ({ texts = [], speed = 60, pauseInterval = 200 }) => {
  const [selectedText, setSelectedText] = useState([]);

  useEffect(() => {
    if (texts.length > 0) {
      // If nested array, treat it as a single set of lines
      if (Array.isArray(texts[0])) {
        setSelectedText(texts[0]);
      } else {
        // Otherwise, select a random text
        const randomIndex = Math.floor(Math.random() * texts.length);
        setSelectedText([texts[randomIndex]]);
      }
    }
  }, [texts]);

  return (
    <div
      className="relative w-full h-full"
      style={{
        fontFamily: "'Press Start 2P', monospace",
        backgroundColor: "transparent",
      }}
    >
      <motion.div
        className="w-full max-w-[100%] text-purple-500 bg-transparent"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {selectedText.length > 0 && (
          <TypeAnimation
            sequence={selectedText.flatMap((line) => [line, pauseInterval])} // Use the pauseInterval prop
            wrapper="p"
            speed={speed}
            style={{
              color: "#A020F0",
              fontSize: window.innerWidth < 1600 && window.innerHeight < 900 ? "15px" : "18px", // Adjust font size for resolutions under 1600x900
              lineHeight: "1.45",
              textAlign: "left",
              whiteSpace: "pre-wrap", // Preserve line breaks
              
            }}
            repeat={Infinity}
          />
        )}
      </motion.div>
    </div>
  );
};

export default AboutCardMatrix;
